module.exports = __webpack_public_path__ + "img/02-6闭环.c0d20f6e.svg";